import { Component, Host, h, Prop } from '@stencil/core';

export interface AhaTag extends HTMLAhaTagElement {}

/**
 * Shows the content in a tag.
 */
@Component({
  tag: 'aha-tag',
  styleUrl: 'aha-tag.css',
  shadow: true,
})
export class AhaTag {
  /**
   * The color of the tag. Can be any CSS color string.
   */
  @Prop({ reflect: true }) color!: string;

  /** Whether to have rounded corners */
  @Prop({ reflect: true }) rounded: boolean = false;

  /**
   * The color of the tags text. Can be any CSS color string.
   */
  @Prop() textColor?: string;

  render() {
    const styles: { [key: string]: string } = {
      '--aha-tag--color': this.color,
      '--aha-tag--text-color': this.textColor || 'white',
    };

    return (
      <Host rounded={this.rounded} style={styles}>
        <slot></slot>
      </Host>
    );
  }
}
